/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_Service_TradeInputs */

const en_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trades`)
};

const es_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oficios`)
};

const fr_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artisanat`)
};

const de_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handwerk`)
};

const ja_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`専門技術サービス`)
};

const zh_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`贸易服务`)
};

const ar_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حرف مهنية`)
};

const id_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perdagangan`)
};

const it_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artigianato`)
};

const ru_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ремонт и услуги`)
};

const pt_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serviços Gerais`)
};

const ko_listing_category_service_trade = /** @type {(inputs: Listing_Category_Service_TradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전문 기술/무역`)
};

/**
* | output |
* | --- |
* | "Trades" |
*
* @param {Listing_Category_Service_TradeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_service_trade = /** @type {((inputs?: Listing_Category_Service_TradeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_Service_TradeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_service_trade(inputs)
	if (locale === "es") return es_listing_category_service_trade(inputs)
	if (locale === "fr") return fr_listing_category_service_trade(inputs)
	if (locale === "de") return de_listing_category_service_trade(inputs)
	if (locale === "ja") return ja_listing_category_service_trade(inputs)
	if (locale === "zh") return zh_listing_category_service_trade(inputs)
	if (locale === "ar") return ar_listing_category_service_trade(inputs)
	if (locale === "id") return id_listing_category_service_trade(inputs)
	if (locale === "it") return it_listing_category_service_trade(inputs)
	if (locale === "ru") return ru_listing_category_service_trade(inputs)
	if (locale === "pt") return pt_listing_category_service_trade(inputs)
	return ko_listing_category_service_trade(inputs)
});